export enum MobilePushStatusMapper {
  SCHEDULED = 'Programmé',
  SENT = 'Envoyé',
}
